var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{
    'arrow': true,
    'arrow--open': _vm.open
  },attrs:{"src":require("./arrow.svg")}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db821762","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../panel-theme/src/js/widgets/ds-arrow.vue
// module id = null
// module chunks = 